import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/social-security-break-even',
  component: () => import('../../routes/SocialSecurityBreakEvenCalculator.svelte'),
  card: {
    id: 'social-security-break-even',
    title: 'Social Security Break-Even',
    description: 'Find the age at which delaying Social Security benefits pays off over claiming early.',
    icon: 'account_balance',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/social-security-break-even',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Social Security Break-Even Calculator – When Does Delaying Benefits Pay Off?',
    description: 'Free Social Security break-even calculator. Compare early vs. delayed claiming strategies and find the age where waiting for higher benefits makes financial sense.',
  },
};

export default meta;